import React, { Suspense, ComponentType } from 'react'
import PageLoader from '../components/ui/page_loader'

const withSuspense = <P extends object>(
    Component: ComponentType<P>,
    Fallback: React.ReactNode = <PageLoader />
) => {
    return (props: P) => (
        <Suspense fallback={Fallback}>
            <Component {...props} />
        </Suspense>
    )
}

export default withSuspense